export function unwrapList(value) {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (Array.isArray(value.data)) {
    return value.data;
  }
  return [];
}

export function unwrapResource(body) {
  if (!body || Array.isArray(body)) {
    return body || null;
  }
  if (body.id || body.first_name || body.role) {
    return body;
  }
  if (body.data && !Array.isArray(body.data)) {
    return body.data;
  }
  return body;
}
